export default __webpack_public_path__ + "static/media/Login-fotografija.6f281117.png";